import "antd/dist/reset.css";
import { Alert, Collapse } from "antd";
import { Card} from "antd";
import React, { useState } from 'react';
import utils from "utils";

const MHELabel = {
  "presenting_problem": "History of Presenting Problems",

//PRE-MORBID CHECKLIST

"attitude" : "Attitude to self, Attitude to others [family, friends, relationships]",
"predominant_mood" : "Predominant mood",
"sensitivity":"Sensitivity",
"adaptability":"Adaptability",
"attention_concentration":"Attention/Concentration",
"motivation":"Motivation",
"activity":"Activity",
"aggression":"Aggression",

 //PERSONALITY TRAITS ('OCEAN')
"openness":"'O'penness",
"notes":"Notes",
"conscientiousness":"'C'onscientiousness",
"extraversion":"'E'xtraversion",
"agreebleness":"'A'greeableness",
"neuroticism":"'N'euroticism",
"attention_persistance" : "Attention, Persistence, Frustration Tolerance",

//EXAMINATION ('ASEPTIC')

//Appearance, Behaviour, Motor Activity
"appearance_values" : "Physical Appearance/Grooming",
"grooming" : "Grooming, Built",
"eye_contact" : "Eye contact",
"clinician_interaction" : "Interactions with Clinician",
"tics" : "Tics, Stereotypes, Mannerisms",
"tics_notes" : "Notes",
"psychomotor_activity" : "Psychomotor Activity",
"psychomotor_activity_notes" : "Notes",
"impulsivity" : "Impulsivity/Oppositionality/Aggression",
"impulsivity_notes" : "Notes",

//Speech
"volume" : "Volume",
"relevant" : "Relevant",
"coherent" : "Coherent",
"articulation" : "Articulation",

//Emotion
"mood_over_a_week" : "Mood",
"mood_over_a_week_notes" : "Notes",
"affect_right_now_subjective" : "Affect - Right now (At the time of evaluation)",
"affect_right_now_subjective" : "Subjective - What patient describes",
"right_mood_value" : "Mood",
"right_mood_notes" : "Notes",
"objective" : "Objective - What Clinician has inferred at the time of the interview?", // API
"objective_mood_value" : "Mood",
"objective_mood_notes" : "Notes",

//Perception
"hallucinations" : "Hallucinations",
"hallucinations_notes" : "Notes",

//Thought
"wishes_test" : "3 Wishes Test",
"my_home" : "My Home",
"stream" : "Stream",
"stream_notes" : "Notes",
"form" : "Form",
"form_notes" : "Notes",
"content" : "Content",
"content_notes" : "Notes",

//Insight
"awarness_illness" : "Awareness of illness",
"awarness_notes" : "Notes",
"attributing_mental_illness" : "Attributing it to mental illness",
"attributing_notes" : "Notes",
"acceptance_treatment" : "Acceptance to treatment",
"acceptance_notes" : "Notes",
"capacity_treatment" : "Capacity to choose a form of treatment",
"capacity_notes" : "Notes",
"consequences" : "Awareness of the consequences of refusing to take treatment",
"consequences_notes" : "Notes",

//Cognitive
"attention" : "Attention & Concentration",
"memory" : "Memory",
"intelligence" : "Clinical Estimate of Intelligence",
"comprehension" : "Comprehension",
"arithmetic_skills" : "Arithmetic skills - Enquire whether he/she has any difficulty in calculation",
"abstraction" : "Abstraction",
"judgement" : "Judgement and Insight",
"personal" : "Personal - What is your future plans? and What is your objective in Life?",
"social" : "Social - Respectful towards Clinician/Doctors",
"comments" : "Comments",
}

const tabList = [
  {
    key: 'tab1',
    tab: 'A',
  },
  {
    key: 'tab2',
    tab: 'S',
  },
  {
    key: 'tab3',
    tab: 'E',
  },
  {
    key: 'tab4',
    tab: 'P',
  },
  {
    key: 'tab5',
    tab: 'T',
  },
  {
    key: 'tab6',
    tab: 'I',
  },
  {
    key: 'tab7',
    tab: 'C',
  },
];

const { Panel } = Collapse;

const MHESummaryChild = (props) => {
  const onChange = (key) => {
    // console.log(key);
  };
  const [activeTabKey1, setActiveTabKey1] = useState('tab1');
  // if(props?.data?.examination?.appearance){
  //   tab1: <ConversionChecklist value ={props?.data?.examination?.appearance || {}} />
  // }
  const contentList = {
    tab1: <ConversionChecklist value ={props?.data?.examination?.appearance || {}} />,
    tab2: <ConversionChecklist value ={props?.data?.examination?.speech || {}} />,
    tab3: <Emotion value ={props?.data?.examination?.emotion || {}} />,
    tab4: <Perception value ={props?.data?.examination?.perception || {}} />,
    tab5: <Thought value ={props?.data?.examination?.thought || {}} />,
    tab6: <Insight value ={props?.data?.examination?.insight || {}} />,
    tab7: <Cognitive value ={props?.data?.examination?.cognitive || {}} />,
  }
  const onTab1Change = (key) => {
    setActiveTabKey1(key);
    // console.log(key);
  };


  return (
    <>
  {props.data?.completion_date ? 
    <Collapse style={{ overflowY:"auto"}} onChange={onChange} bordered={false} expandIconPosition= "start" ghost = {true} className='mhe-list-container'>
      <Panel header={<div>{ utils.FormatDate(props?.data?.completion_date, "DATE_14")}, { utils.FormatDate(props?.data?.completion_date, "TIME_1")} </div>} key="1" extra={utils.FirstNameLastName(utils.salutationPrefixName(props?.data?.doctor_salutation,utils.getDisplayName(props?.data?.consultation_doctor, props?.data?.doctor_last_name)), "250px")}>
        <div className="mhe-box-content"  >
          <div className=" mhe-box-content-label">
            <div style={{fontWeight: "500", paddingLeft: "9px"}}> {MHELabel["presenting_problem"]} </div>
            <div>  :  </div> 
            <div>{utils.LineSplit(props?.data?.presenting_problem)}</div> 
            </div> 
          </div>
        <Collapse defaultActiveKey="1" bordered={false} expandIconPosition= "start" ghost = {true}>
          {props?.data?.pre_morbid_checklist ? 
          <Panel header="PRE-MORBID CHECKLIST" key="a">
              <ConversionChecklist value ={props?.data?.pre_morbid_checklist} />
          </Panel>
          : null}
          {props?.data?.personality_traits ? 
          <Panel header="PERSONALITY TRAITS ('OCEAN')" key="b">
          <>
            <ConversionChecklist value ={props?.data?.personality_traits} />
            </>
          </Panel>
          : null}
          {props?.data?.examination ? 
          <Panel header={<>{ props.user_type=='adolescent' ? <div>EXAMINATION ('ASEPTC')</div> : <div>EXAMINATION ('ASEPTIC')</div>}</>} key="c">
          <Card
        style={{
          width: '100%',
        }}
        tabList={tabList.filter((element)=>{if(!(element.tab==='I' && props.user_type=='adolescent')){return element}})}
        activeTabKey={activeTabKey1}
        onTabChange={(key) => {
          onTab1Change(key);
        }}
      >
        {/* {console.log(contentList)} */}
        {contentList[activeTabKey1]}
      </Card>
          </Panel>
          : null }
        </Collapse>
      </Panel>
    </Collapse>
: null}
    </>
  );
};

  const ConversionChecklist = React.memo((props) => {
  let output = [];
  try {
    for (const [keys, values] of Object.entries(props.value || {})) {
      if (typeof values === "object") {
        let result = checkBoxSummary(keys,values) ;
        output = Array.isArray(result) ? [...output , ...result] : output ;
      }else{
        values ? output.push(keys + " : " + utils.ConvertToPascalCase(values)) : ''
      }
    }
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0  ? output.map((i, j) => {
      let split = i.split(/:(.*)/s);
      split[0] = summaryConverter(split[0]);      
      if(split[1].includes("jargon Neologisms")==true){
        return(
          <div className="mhe-box-content"  key={j}>
           <div className="mhe-box-content-label">
           <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
           <div> : </div> 
           <div>{"Jargon/Neologisms"}</div>
           </div>
         </div>   
       )
      }else if(split[0].includes("Activity") && split[1].includes("High") == true ){
        return(
          <div className="mhe-box-content"  key={j}>
           <div className="mhe-box-content-label">
           <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
           <div> : </div> 
           <div>{"Hyperactive"}</div>
           </div>
         </div>   
       )
      }
      else{
      return(
         <div className="mhe-box-content"  key={j}>
          <div className="mhe-box-content-label">
          <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
          <div> : </div> 
          <div>{utils.ConvertToPascalCase(split[1])}</div>
          </div>
        </div>   
      )
      }
  }) : <div style={{textAlign: "center"}}>No data found </div>}
})

const checkBoxSummary = (keys,values) => {
  let output = [] ;
  try{
    let {notes = ''} = values
    for (const [key, value] of Object.entries(values)) {    
      if(key == "notes") continue  
      let dataCheck = "";
      if(Array.isArray(value)){
        for (let { is_selected, selected_value = '' } of value) {
        dataCheck += is_selected ? selected_value + " | " : "";
        }
      }else{
        dataCheck +=  value ?  utils.ConvertToPascalCase(value)  + ' | ' : ' | ';
      }
      if (dataCheck)
       output.push(keys + " : " + dataCheck.substring(0, dataCheck.length - 2));
    }
    notes ? output.push("notes : "+ utils.ConvertToPascalCase(notes)) : ''
  }catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output ; 
  }
}

const checkBoxData = (value)=>{
  let result = '';
  if(!value){
    return "";
  }
  for (let { is_selected, selected_value = '' } of value) {
    result += is_selected ? selected_value + " | " : "";
  }
  return result ? result.substring(0, result.length - 2) : '';
}
const affectData = (value)=>{
  let result = '';
  if(!value){
    return "";
  }
  for (let affect of value) {
    result += affect ? utils.ConvertToPascalCase(affect) + " | " : "";
  }
  return result ? result.substring(0, result.length - 2) : '';
}


const Emotion = React.memo((props) => {
  let output = [];
  let affectValues = [];
  try {
    let {mood_over_a_week : {mood_value ,notes} = '' , affect: {affect_one,affect_two,affect_three} = ""} = props.value;
    let subOutput = mood_value;
    subOutput && output.push("mood_over_a_week :" + subOutput)
    notes && output.push("mood_over_a_week_notes :" + notes)
    // let affectvalues = affect_one
    if(affect_one!==undefined) affectValues.push(affect_one)
    if(affect_two!==undefined) affectValues.push(affect_two)
    if(affect_three!==undefined) affectValues.push(affect_three)
    let subOutputAffect = affectData(affectValues)
    affect_one && output.push("affect:"+ subOutputAffect)
    
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0  ? output.map((i, j) => {
      let split = i.split(/:(.*)/s);
      split[0] = summaryConverter(split[0]);
      return(
      <div className="mhe-box-content"  key={j}>
          <div className="mhe-box-content-label">
          <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
          <div> : </div> 
          <div>{utils.ConvertToPascalCase(split[1])}</div>
          </div>
        </div>   
      )
  }) : <div style={{textAlign: "center"}}>No data found </div>}
})

const Perception = React.memo((props) => {
  let output = [];
  try {
    let {hallucinations : {hallucination_values , notes} = ''} = props.value;
    if(typeof(hallucination_values)=="object"){
      let subOutput = checkBoxData(hallucination_values);
      subOutput && output.push("hallucinations :" + subOutput)
    }
    if(typeof(hallucination_values)=="string"){
      hallucination_values && output.push("hallucinations :" + hallucination_values)
    }   
    notes && output.push("hallucinations_notes :" + notes)
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0  ? output.map((i, j) => {
      let split = i.split(/:(.*)/s);
      split[0] = summaryConverter(split[0]);
      return(
      <div className="mhe-box-content" key={j}>
          <div className="mhe-box-content-label">
          <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
          <div> : </div> 
          <div>{utils.ConvertToPascalCase(split[1])}</div>
          </div>
        </div>   
      )
  }) : <div style={{textAlign: "center"}}>No data found </div>}
})

const Thought = React.memo((props) => {
  let output = [];
  try {
    let {wishes_test = '' ,my_home = '', stream :{stream_values , notes} = '' , form : {form_values , notes:form_notes} = '',content : {content_values , notes:content_notes} = '' ,form_content="" } = props.value;
    wishes_test && output.push("wishes_test :" + wishes_test)
    my_home && output.push("my_home :" + my_home)
    let subOutput = checkBoxData(stream_values);
    subOutput && output.push("stream :" + subOutput)
    notes && output.push("stream_notes :" + notes)
    subOutput = checkBoxData(form_values);
    subOutput && output.push("form :" + subOutput)
    form_content && output.push("Form & Content:"+ form_content)
    form_notes && output.push("form_notes :" + form_notes)
    subOutput = checkBoxData(content_values);
    subOutput && output.push("content :" + subOutput)
    content_notes && output.push("content_notes :" + content_notes)
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0  ? output.map((i, j) => {
      let split = i.split(/:(.*)/s);
      split[0] = summaryConverter(split[0]);
      return(
       <div className="mhe-box-content"  key={j}>
          <div className="mhe-box-content-label">
          <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
          <div> : </div> 
          <div>{utils.ConvertToPascalCase(split[1])} </div>
          </div>
        </div>   
      )
  }) : <div style={{textAlign: "center"}}>No data found </div>}
})

const Insight = React.memo((props) => {
  let output = [];
  try {
    let {awarness : {awarness_illness ,notes} = '' ,attributing : {attributing_mental_illness , notes : attributing_notes} = '',acceptance : {acceptance_treatment , notes : acceptance_notes} = '' , capacity : {capacity_treatment ,notes : capacity_notes } = '' ,consequences:{consequences ,notes :  consequences_notes} = ''  } = props.value;
    awarness_illness ?  output.push("awarness_illness : Yes") : output.push("awarness_illness : No")
    notes && output.push("awarness_notes :" + notes)

    
    attributing_mental_illness ?  output.push("attributing_mental_illness : Yes") : output.push("attributing_mental_illness : No")
    attributing_notes && output.push("attributing_notes :" + attributing_notes)

    
    acceptance_treatment ?  output.push("acceptance_treatment : Yes") : output.push("acceptance_treatment : No")
    acceptance_notes && output.push("acceptance_notes :" + acceptance_notes)

    
    capacity_treatment ?  output.push("capacity_treatment : Yes") : output.push("capacity_treatment : No")
    capacity_notes && output.push("capacity_notes :" + capacity_notes)

    
    consequences ?  output.push("consequences : Yes") : output.push("consequences : No")
    consequences_notes && output.push("consequences_notes :" + consequences_notes)

  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0  ? output.map((i, j) => {
      let split = i.split(/:(.*)/s);
      split[0] = summaryConverter(split[0]);
      return(
       <div className="mhe-box-content" key={j}>
          <div className="mhe-box-content-label">
          <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
          <div> : </div> 
          <div>{utils.ConvertToPascalCase(split[1])} </div>
          </div>
        </div>   
      )
  }) : <div style={{textAlign: "center"}}>No data found </div>}
})

const Cognitive = React.memo((props) => {
  let output = [];
  try {
    let {attention : {attention_values} = '' ,memory : {memory_values}  = '', intelligence : {intelligence_values}  = '', comprehension : {comprehension_values} = '', arithmetic_skills  = '' , abstraction : {abstraction_values} = '', judgement : {judgement_values} = '' , personal = '' , social : {social_respectful , comments} = '' } = props.value;
    attention_values && output.push("attention :" + attention_values)
    memory_values && output.push("memory :" + memory_values)
    intelligence_values && output.push("intelligence :" + intelligence_values)
    comprehension_values && output.push("comprehension :" + comprehension_values)

    let result = arithmetic_skills ? "Yes": "No";
    typeof arithmetic_skills === "boolean" ? output.push("arithmetic_skills : " + result) : '';
    
    abstraction_values && output.push("abstraction :" + abstraction_values)
    judgement_values && output.push("judgement :" + judgement_values)
    personal && output.push("personal :" + personal)
    result = social_respectful ? "Yes": "No";
    typeof social_respectful === "boolean" ? output.push("social_respectful : " + result) : '';
    
    comments && output.push("comments :" + comments)
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0  ? output.map((i, j) => {
      let split = i.split(/:(.*)/s);
      split[0] = summaryConverter(split[0]);
      return(
       <div className="mhe-box-content" key={j}>
          <div className="mhe-box-content-label">
          <div style={{fontWeight: "500", paddingLeft: "9px"}}> {split[0]}  </div> 
          <div> : </div> 
          <div>{utils.ConvertToPascalCase(split[1])} </div>
          </div>
        </div>   
      )
  }) : <div style={{textAlign: "center"}}>No data found </div>}
})

const summaryConverter = (val) => {
  let result = MHELabel[val.trim()] ? MHELabel[val.trim()] : utils.ConvertToPascalCase(val);
  return result;
}

export default MHESummaryChild;